// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.chart__uM7g0 {
  border-bottom: 1px solid var(--tables-primary-row-stroke);
}

.chartHead__vYNop {
  min-height: 84px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 15px 25px;
  flex-wrap: wrap;
  gap: 15px;
}

.chartInfo__n2vs6 {
  display: flex;
  align-items: center;
  column-gap: 8px;
  cursor: pointer;
}

.chartArrowIcon__z2sfr {
  width: 16px;
  height: 16px;
  transition: all 0.3s ease-in-out;
}
.chartArrowIcon__z2sfr path {
  stroke: var(--title-inputs-sections-drop-down-count);
}

.chartArrowIconIsOpen__JXM2r {
  font-size: 13px;
  font-weight: 400;
  transform: rotate(-180deg);
}

.chartInfoTitle__b8EEW {
  font-size: 14px;
  font-weight: 500;
  line-height: 17px;
  color: var(--tables-title-text);
  text-transform: uppercase;
}

.chartActions__eyDrF {
  display: flex;
  align-items: flex-end;
  column-gap: 10px;
}

.chartTwfActions__RKPYA {
  display: grid;
  grid-template-columns: 24px auto 175px 24px;
  align-items: flex-end;
  column-gap: 10px;
}

.chartFftActions__bmPK3 {
  display: grid;
  grid-template-columns: 24px auto auto 175px 24px;
  align-items: flex-end;
  column-gap: 10px;
}
@media (max-width: 1100px) {
  .chartFftActions__bmPK3 {
    grid-template-columns: 24px auto auto 145px 24px;
    column-gap: 5px;
  }
}

.downloadActions__UZIgE {
  cursor: pointer;
  margin-bottom: 5px;
  padding: 3px 10px;
}

.refetchIcon__jVGu5 {
  margin-bottom: 7px;
  padding: 1px 0;
  cursor: pointer;
}
.refetchIcon__jVGu5 path {
  stroke: var(--buttons-surface);
}
.refetchIcon__jVGu5:focus {
  outline: none;
}

.chartView__eECFv {
  height: 0;
  overflow: hidden;
  background-color: var(--tables-primary-row-surface-default);
  border-top: 1px solid var(--tables-primary-row-stroke);
  transition: height 1s cubic-bezier(0.66, 0, 0.34, 1);
}

.chartViewOpen__E3eWX {
  height: 340px;
}

.chartWrapper__HHLUz {
  padding: 20px 25px;
}
.chartWrapper__HHLUz .highcharts-plot-line {
  outline: none;
}
.chartWrapper__HHLUz .highcharts-plot-line-label {
  width: 100%;
  left: 0 !important;
}
.chartWrapper__HHLUz .alert-plot-line {
  display: flex;
  justify-content: flex-end;
}
.chartWrapper__HHLUz .alert-plot-line div {
  display: flex;
  align-items: center;
  column-gap: 4px;
  background-color: var(--tables-primary-row-surface-default);
}
.chartWrapper__HHLUz .alert-plot-line span {
  width: 12px;
  height: 10px;
  display: block;
  border-radius: 2px;
}

.printTitle__lLTYS {
  font-size: 14px;
  font-weight: 500;
  line-height: 17px;
  color: #000;
  text-transform: uppercase;
  overflow: hidden;
  height: 0;
}

.skeletonChart__PXv3W {
  width: calc(100% - 50px);
  height: 295px;
  margin: 20px 25px;
}

@media print {
  @page {
    size: 100vw 100vh;
    margin: 0.5cm;
    padding: 0.5cm;
  }
  .onPrintChart {
    width: 100vw;
    height: 33vh;
    border: none;
  }
  .chartViewOnPrint {
    width: 100%;
    height: 100%;
  }
  .onPrintHead {
    overflow: hidden;
    height: 0;
  }
  .onPrintTitle {
    height: auto;
    margin-top: 15px;
    margin-bottom: 15px;
  }
  .onPrintWrapper {
    padding: 0;
  }
  .printSensorHighchartsChart .highcharts-root {
    width: 720px;
    height: 250px;
  }
}
.noData__QM8x6 {
  font-size: 12px;
  text-transform: uppercase;
  color: var(--tables-secondary-row-sub-title-text);
  width: 100%;
  height: 300px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.wos__fyNEL {
  margin-bottom: 9px;
  padding: 3px 10px;
  background-color: var(--buttons-surface);
  border-radius: 3px;
  color: #fff;
  cursor: pointer;
}

.wosFft__k6wop {
  margin-left: auto;
  margin-top: 12px;
  padding: 3px 10px;
  background-color: var(--buttons-surface);
  border-radius: 3px;
  color: #fff;
  cursor: pointer;
}

.datepickerPopper__Faq1I {
  translate: -90px;
}

.skeletonWrapper__fJGZ5 {
  min-height: 84px;
  padding: 15px 25px;
  display: flex;
  align-items: center;
  border-bottom: 1px solid var(--tables-primary-row-stroke);
}

.skeletonText__XmjND {
  width: 100%;
  height: 39px;
}`, "",{"version":3,"sources":["webpack://./../src/pages/SensorDetails/components/ChartView/style.module.scss"],"names":[],"mappings":"AA0EA;EACE,yDAAA;AAzEF;;AA4EA;EACE,gBAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,kBAAA;EACA,eAAA;EACA,SAAA;AAzEF;;AA4EA;EACE,aAAA;EACA,mBAAA;EACA,eAAA;EACA,eAAA;AAzEF;;AA4EA;EACE,WAAA;EACA,YAAA;EACA,gCAAA;AAzEF;AA2EE;EACE,oDAAA;AAzEJ;;AA6EA;EACE,eAAA;EACA,gBAAA;EACA,0BAAA;AA1EF;;AA6EA;EACE,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,+BAAA;EACA,yBAAA;AA1EF;;AA6EA;EACE,aAAA;EACA,qBAAA;EACA,gBAAA;AA1EF;;AA6EA;EACE,aAAA;EACA,2CAAA;EACA,qBAAA;EACA,gBAAA;AA1EF;;AA6EA;EACE,aAAA;EACA,gDAAA;EACA,qBAAA;EACA,gBAAA;AA1EF;AA4EE;EANF;IAOI,gDAAA;IACA,eAAA;EAzEF;AACF;;AA4EA;EACE,eAAA;EACA,kBAAA;EACA,iBAAA;AAzEF;;AA4EA;EACE,kBAAA;EACA,cAAA;EACA,eAAA;AAzEF;AA2EE;EACE,8BAAA;AAzEJ;AA4EE;EACE,aAAA;AA1EJ;;AA8EA;EACE,SAAA;EACA,gBAAA;EACA,2DAAA;EACA,sDAAA;EACA,oDAAA;AA3EF;;AA8EA;EACE,aAAA;AA3EF;;AA8EA;EACE,kBAAA;AA3EF;AA8EI;EACE,aAAA;AA5EN;AA8EI;EACE,WAAA;EACA,kBAAA;AA5EN;AA8EI;EACE,aAAA;EACA,yBAAA;AA5EN;AA8EM;EACE,aAAA;EACA,mBAAA;EACA,eAAA;EAEA,2DAAA;AA7ER;AAgFM;EACE,WAAA;EACA,YAAA;EACA,cAAA;EACA,kBAAA;AA9ER;;AAoFA;EACE,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,WAAA;EACA,yBAAA;EACA,gBAAA;EACA,SAAA;AAjFF;;AAoFA;EACE,wBAAA;EACA,aAAA;EACA,iBAAA;AAjFF;;AAoFA;EACE;IACE,iBAAA;IACA,aAAA;IACA,cAAA;EAjFF;EAqFE;IACE,YAAA;IACA,YAAA;IACA,YAAA;EAnFJ;EAqFE;IACE,WAAA;IACA,YAAA;EAnFJ;EAqFE;IACE,gBAAA;IACA,SAAA;EAnFJ;EAqFE;IACE,YAAA;IACA,gBAAA;IACA,mBAAA;EAnFJ;EAqFE;IACE,UAAA;EAnFJ;EAsFI;IACE,YAAA;IACA,aAAA;EApFN;AACF;AAyFA;EACE,eAAA;EACA,yBAAA;EACA,iDAAA;EACA,WAAA;EACA,aAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AAvFF;;AA0FA;EACE,kBAAA;EACA,iBAAA;EACA,wCAAA;EACA,kBAAA;EACA,WAAA;EACA,eAAA;AAvFF;;AA0FA;EACE,iBAAA;EACA,gBAAA;EACA,iBAAA;EACA,wCAAA;EACA,kBAAA;EACA,WAAA;EACA,eAAA;AAvFF;;AA0FA;EACE,gBAAA;AAvFF;;AA0FA;EACE,gBAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,yDAAA;AAvFF;;AA0FA;EACE,WAAA;EACA,YAAA;AAvFF","sourcesContent":["%scrollbar-style {\n  scrollbar-color: rgba(0, 0, 0, 0.2) rgba(0, 0, 0, 0.05);\n  scrollbar-width: auto;\n\n  &::-webkit-scrollbar {\n    width: 6px;\n    height: 6px;\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: rgba(0, 0, 0, 0.05);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: rgba(0, 0, 0, 0.2);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb:hover {\n    background: #888;\n    border-radius: 3px;\n  }\n}\n@mixin scrollBar {\n  &::-webkit-scrollbar {\n    width: 6px;\n    height: 6px;\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: rgba(0, 0, 0, 0.05);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: rgba(0, 0, 0, 0.2);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb:hover {\n    background: #888;\n    border-radius: 3px;\n  }\n}\n\n@mixin ellipsis-text {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: pre-wrap;\n  word-wrap: break-word;\n  display: -webkit-box;\n  -webkit-box-orient: vertical;\n}\n\n@mixin tooltip {\n  padding: 8px !important;\n  opacity: 1 !important;\n  filter: drop-shadow(0 0 1px rgba(12, 26, 75, 0.24));\n  border-radius: 4px !important;\n  text-align: left !important;\n}\n\n@mixin modalTitle {\n  color: var(--header-title-main);\n  font-size: 18px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 20px;\n  text-transform: uppercase;\n}\n\n.chart {\n  border-bottom: 1px solid var(--tables-primary-row-stroke);\n}\n\n.chartHead {\n  min-height: 84px;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 15px 25px;\n  flex-wrap: wrap;\n  gap: 15px;\n}\n\n.chartInfo {\n  display: flex;\n  align-items: center;\n  column-gap: 8px;\n  cursor: pointer;\n}\n\n.chartArrowIcon {\n  width: 16px;\n  height: 16px;\n  transition: all 0.3s ease-in-out;\n\n  path {\n    stroke: var(--title-inputs-sections-drop-down-count);\n  }\n}\n\n.chartArrowIconIsOpen {\n  font-size: 13px;\n  font-weight: 400;\n  transform: rotate(-180deg);\n}\n\n.chartInfoTitle {\n  font-size: 14px;\n  font-weight: 500;\n  line-height: 17px;\n  color: var(--tables-title-text);\n  text-transform: uppercase;\n}\n\n.chartActions {\n  display: flex;\n  align-items: flex-end;\n  column-gap: 10px;\n}\n\n.chartTwfActions {\n  display: grid;\n  grid-template-columns: 24px auto 175px 24px;\n  align-items: flex-end;\n  column-gap: 10px;\n}\n\n.chartFftActions {\n  display: grid;\n  grid-template-columns: 24px auto auto 175px 24px;\n  align-items: flex-end;\n  column-gap: 10px;\n\n  @media (max-width: 1100px) {\n    grid-template-columns: 24px auto auto 145px 24px;\n    column-gap: 5px;\n  }\n}\n\n.downloadActions {\n  cursor: pointer;\n  margin-bottom: 5px;\n  padding: 3px 10px;\n}\n\n.refetchIcon {\n  margin-bottom: 7px;\n  padding: 1px 0;\n  cursor: pointer;\n\n  path {\n    stroke: var(--buttons-surface);\n  }\n\n  &:focus {\n    outline: none;\n  }\n}\n\n.chartView {\n  height: 0;\n  overflow: hidden;\n  background-color: var(--tables-primary-row-surface-default);\n  border-top: 1px solid var(--tables-primary-row-stroke);\n  transition: height 1s cubic-bezier(0.66, 0, 0.34, 1);\n}\n\n.chartViewOpen {\n  height: 340px;\n}\n\n.chartWrapper {\n  padding: 20px 25px;\n\n  :global {\n    .highcharts-plot-line {\n      outline: none;\n    }\n    .highcharts-plot-line-label {\n      width: 100%;\n      left: 0 !important;\n    }\n    .alert-plot-line {\n      display: flex;\n      justify-content: flex-end;\n\n      div {\n        display: flex;\n        align-items: center;\n        column-gap: 4px;\n\n        background-color: var(--tables-primary-row-surface-default);\n      }\n\n      span {\n        width: 12px;\n        height: 10px;\n        display: block;\n        border-radius: 2px;\n      }\n    }\n  }\n}\n\n.printTitle {\n  font-size: 14px;\n  font-weight: 500;\n  line-height: 17px;\n  color: #000;\n  text-transform: uppercase;\n  overflow: hidden;\n  height: 0;\n}\n\n.skeletonChart {\n  width: calc(100% - 50px);\n  height: 295px;\n  margin: 20px 25px;\n}\n\n@media print {\n  @page {\n    size: 100vw 100vh;\n    margin: 0.5cm;\n    padding: 0.5cm;\n  }\n\n  :global {\n    .onPrintChart {\n      width: 100vw;\n      height: 33vh;\n      border: none;\n    }\n    .chartViewOnPrint {\n      width: 100%;\n      height: 100%;\n    }\n    .onPrintHead {\n      overflow: hidden;\n      height: 0;\n    }\n    .onPrintTitle {\n      height: auto;\n      margin-top: 15px;\n      margin-bottom: 15px;\n    }\n    .onPrintWrapper {\n      padding: 0;\n    }\n    .printSensorHighchartsChart {\n      .highcharts-root {\n        width: 720px;\n        height: 250px;\n      }\n    }\n  }\n}\n\n.noData {\n  font-size: 12px;\n  text-transform: uppercase;\n  color: var(--tables-secondary-row-sub-title-text);\n  width: 100%;\n  height: 300px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.wos {\n  margin-bottom: 9px;\n  padding: 3px 10px;\n  background-color: var(--buttons-surface);\n  border-radius: 3px;\n  color: #fff;\n  cursor: pointer;\n}\n\n.wosFft {\n  margin-left: auto;\n  margin-top: 12px;\n  padding: 3px 10px;\n  background-color: var(--buttons-surface);\n  border-radius: 3px;\n  color: #fff;\n  cursor: pointer;\n}\n\n.datepickerPopper {\n  translate: -90px;\n}\n\n.skeletonWrapper {\n  min-height: 84px;\n  padding: 15px 25px;\n  display: flex;\n  align-items: center;\n  border-bottom: 1px solid var(--tables-primary-row-stroke);\n}\n\n.skeletonText {\n  width: 100%;\n  height: 39px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"chart": `chart__uM7g0`,
	"chartHead": `chartHead__vYNop`,
	"chartInfo": `chartInfo__n2vs6`,
	"chartArrowIcon": `chartArrowIcon__z2sfr`,
	"chartArrowIconIsOpen": `chartArrowIconIsOpen__JXM2r`,
	"chartInfoTitle": `chartInfoTitle__b8EEW`,
	"chartActions": `chartActions__eyDrF`,
	"chartTwfActions": `chartTwfActions__RKPYA`,
	"chartFftActions": `chartFftActions__bmPK3`,
	"downloadActions": `downloadActions__UZIgE`,
	"refetchIcon": `refetchIcon__jVGu5`,
	"chartView": `chartView__eECFv`,
	"chartViewOpen": `chartViewOpen__E3eWX`,
	"chartWrapper": `chartWrapper__HHLUz`,
	"printTitle": `printTitle__lLTYS`,
	"skeletonChart": `skeletonChart__PXv3W`,
	"noData": `noData__QM8x6`,
	"wos": `wos__fyNEL`,
	"wosFft": `wosFft__k6wop`,
	"datepickerPopper": `datepickerPopper__Faq1I`,
	"skeletonWrapper": `skeletonWrapper__fJGZ5`,
	"skeletonText": `skeletonText__XmjND`
};
module.exports = ___CSS_LOADER_EXPORT___;
